import classes from '../BarcodesMultiList/css/barcodesList.module.css';

import React from 'react';
import DropdownComponent from '../Dropdown/DropdownComponent';
import useAlert from 'hooks/useAlert';

const MultiSelectBoxItem = ({
  keyValue = 'id',
  id,
  item,
  isLastItem,
  onChange,
  onAddElementClick,
  onDeleteElementClick,
  dataSource = [],
  index,
  disabled,
}) => {
  const { showAlert } = useAlert();
  const [hovered, setHovered] = React.useState(false);

  const handleDeleteElement = () => {
    alarmSureDeleteElement(() => onDeleteElementClick(index))
  }

  const alarmSureDeleteElement = (callback) =>
    showAlert(`Вы уверены что хотите удалить?`, 'sure', callback);

  return (
    <div
      className={classes.containerParent}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className={classes.container}>
        <div className={classes.barcodeContainer} style={{ minWidth: '250px' }}>
          <DropdownComponent
            key={`${id}${item?.id}`}
            items={dataSource}
            selectedKey={item?.id ?? 0}
            onChange={(val) => onChange(index, val, keyValue)}
            disabled={disabled}
          />
        </div>
      </div>
      <div className={`${classes.buttons} `}>
        {hovered && !disabled && (
          <>
            {id > 0 && (
              <div
                className={classes.buttonClear}
                onClick={handleDeleteElement}
              >
                <div className={'close_icon'}></div>
              </div>
            )}
            {isLastItem && (
              <div className={classes.buttonAdd} onClick={() => onAddElementClick()}>
                <div className={'plus_icon'}></div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MultiSelectBoxItem;
